var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('vbt-search',{attrs:{"items":_vm.searchFieldsConfig},on:{"reset":_vm.onResetSearch,"search":_vm.onSearch},model:{value:(_vm.searchData),callback:function ($$v) {_vm.searchData=$$v},expression:"searchData"}}),_c('vbt-content-box',{attrs:{"loading":_vm.isLoading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"go-back-btn":_vm.goBack,"title":"Information"}},[_c('vbt-table',{attrs:{"headers":_vm.headers,"items":_vm.inputMessages,"show-details-action":""},on:{"click:details":function (ref) {
      var id = ref.id;

      return _vm.$router.push({
        name: 'inputMessage',
        params: { id: id },
        query: { suffix: _vm.suffix },
      });
}},scopedSlots:_vm._u([{key:"id",fn:function(ref){
      var id = ref.item.id;
return [_c('router-link',{staticClass:"info--text",attrs:{"to":{
            name: 'inputMessage',
            params: { id: id },
            query: { suffix: _vm.suffix },
          }}},[_vm._v(" "+_vm._s(id)+" ")])]}},{key:"created",fn:function(ref){
          var created = ref.item.created;
return [_vm._v(" "+_vm._s(_vm.formatDate(created))+" ")]}},{key:"type",fn:function(ref){
          var type = ref.item.type;
return [_vm._v(" "+_vm._s(type)+" ")]}},{key:"irSuccess",fn:function(ref){
          var irSuccess = ref.item.irSuccess;
return [_c('kernel-status-badge',{attrs:{"status":_vm.irResultByValue[irSuccess]}},[_vm._v(" "+_vm._s(irSuccess)+" ")])]}},{key:"orderOuterId",fn:function(ref){
          var orderOuterId = ref.item.orderOuterId;
return [(orderOuterId)?_c('router-link',{class:_vm.$_themeTextColorClass,attrs:{"to":{
            name: 'order',
            params: { id: orderOuterId },
            query: { suffix: _vm.suffix },
          }}},[_vm._v(" "+_vm._s(orderOuterId)+" ")]):_c('span',[_vm._v(" - ")])]}},{key:"orderItemOuterId",fn:function(ref){
          var orderItemOuterId = ref.item.orderItemOuterId;
return [_vm._v(" "+_vm._s(orderItemOuterId || '-')+" ")]}}])}),_c('vbt-pagination',{attrs:{"items-count":_vm.pagedItemsCount},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }